<template>
  <div class="c-layers-list">
    <!-- <ul class="c-layers-list__list">
      <li
        :class="getClass(item.id)"
        v-for="item in layers"
        :key="item.id"
        @click="toggleLayer(item.id)"
      >
        <div class="c-layers-list__icon">
          <i class="el-icon-loading" v-if="isLoading(item.id)" />
          <r-icon v-else :name="item.icon" :size="18" />
        </div>
        <div class="c-layers-list__info">
          <r-text type="default">{{ item.title }}</r-text>
        </div>
        <div class="c-layers-list__actions" v-if="isActive(item.id)">
          <r-icon
            @click.native="toggleSettings($event, item.id)"
            name="settings"
            :size="18"
          />
        </div>
      </li>
    </ul> -->
    <r-list
      :list="layers"
      :toolsList="tools"
      :activeList="activeLayers"
      :loadingList="loadingLayers"
      @node-click-handler="e => toggleLayer(e)"
      @tool-click-handler="e => toggleSettings(e)"
    />
  </div>
</template>

<script>
const layersToRenderDatatypes = ["nodes", "links", "zones", "events"];
const layersName = {
  nodes: "Узлы (nodes)",
  links: "Отрезки (links)",
  zones: "Районы (zones)",
  events: "События (events)"
};
const layersIcons = {
  nodes: "node",
  zones: "polygon",
  links: "line",
  events: "road-accident"
};

export default {
  data() {
    return {
      tools: [
        {
          id: 1,
          title: "settings",
          icon: "settings"
        }
      ]
    };
  },
  computed: {
    layers() {
      return this.$store.state.calculations.model.children
        .filter(l => layersToRenderDatatypes.includes(l.datatype))
        .map(l => ({
          ...l,
          title: layersName[l.datatype],
          icon: layersIcons[l.datatype]
        }));
    },
    activeLayers() {
      return this.$store.state.calculations.activeLayers;
    },
    loadingLayers() {
      return this.$store.state.calculations.loadingLayers;
    }
  },
  methods: {
    isActive(id) {
      return this.activeLayers.includes(id);
    },
    isLoading(id) {
      return this.loadingLayers.includes(id);
    },
    toggleLayer({ id }) {
      if (this.isLoading(id)) return;

      if (this.isActive(id)) {
        this.$cControllers.layers.toggleLayerOff(id);
      } else {
        this.$cControllers.layers.toggleLayerOn(id, true);
      }
    },
    toggleSettings({ item }) {
      const { id } = item;

      if (!this.isActive(id)) return;

      const { settingsId } = this.$store.state.calculations;

      const value = id === settingsId ? null : id;

      this.$store.commit("SET_CALC_FIELD", {
        field: "settingsId",
        value
      });
    }
  }
};
</script>

<style lang="scss">
.c-layers-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 8px;
}
</style>
